<template>
  <label for="countrySelect">
    <select :class="selectClass" name="countrySelect" ref="select" :value="value"
        @input="updateValue" :disabled="!options">
      <option value="" disabled selected>{{placeholder}}</option>
      <option v-for="option in options" :value="option.value" :key="option.value">
        {{ option.name }}
      </option>
    </select>
    <select-arrow-icon iconClass="icon" />
  </label>
</template>

<style scoped>

  select {
    border: 1px solid #7a7a7a;
    border-radius: 8px;
    background-color: transparent;
    padding: 8px;
    height: 40px;
    width: 220px;

    box-sizing: border-box;
    display: inline-block;
    vertical-align: middle;

    -moz-appearance: none;
    -webkit-appearance: none;
    appearance: none;
  }

  option {
    width: 220px;
  }

  .icon {
    position: relative;
    right: 32px;
    top: 8px;
    z-index: -999;
  }
</style>

<script>
import SelectArrowIcon from '@/components/icons/SelectArrowIcon.vue';

export default {
  name: 'select-input',
  props: {
    value: {
      // eslint-disable-next-line
      type: String | null,
      required: true,
    },
    options: {
      // eslint-disable-next-line
      type: Array | undefined,
      required: true,
    },
    selectClass: {
      type: String,
      required: false,
    },
    placeholder: {
      type: String,
      required: false,
    },
  },
  methods: {
    updateValue(e) {
      this.$emit('input', e.target.value);
    },
    onIconClick() {
      this.$refs.select.click();
    },
  },
  components: {
    SelectArrowIcon,
  },
};
</script>
